import React from 'react';
import { View, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';

import Notes from 'app/src/components/Notes/List';
import { Button } from 'app/src/elements/buttons';
import Modal from 'app/src/elements/Modal';
import { Subtitle, Text } from 'app/src/styles';
import { datetimeShort } from 'app/src/utils/formatting';
import { Link } from 'app/src/utils/routing';

import { UPDATE_SYSTEM_ALERT_DISMISSED } from './queries';

const CLEAR_DISMISSED_CONFIRMATION = 'Really clear dismissal?';

const SystemAlert = ({ systemAlert, refetch, setShow }) => {
  const [updateSystemAlertDismissed] = useMutation(
    UPDATE_SYSTEM_ALERT_DISMISSED, {
      onCompleted: () => setShow(false)
    }
  );

  const submitSystemAlertDismissed = dismissed => {
    if (dismissed || window.confirm(CLEAR_DISMISSED_CONFIRMATION)) {
      updateSystemAlertDismissed({
        variables: { id: systemAlert.id, dismissed }
      })
    }
  };

  const documentation = systemAlert.alertDocumentation ||
    systemAlert.dataCheckDocumentation;

  const title = `${datetimeShort(systemAlert.createdAt)} (${systemAlert.id})`;

  return (
    <Modal title={title} setShow={setShow}>
      {systemAlert.alert && (
        <Text style={{ color: '#ff0000', fontWeight: 900 }}>ALERT!</Text>
      )}

      <Text>{systemAlert.message}</Text>

      {systemAlert.dismissedAt ? (
        <View style={{ flexDirection: 'row', gap: 10 }}>
          <Text>Dismissed {datetimeShort(systemAlert.dismissedAt)}</Text>
          <Pressable onPress={() => submitSystemAlertDismissed(false)}>
            <Text>[Clear]</Text>
          </Pressable>
        </View>
      ) : (
        <Button
          label="Dismiss"
          onPress={() => submitSystemAlertDismissed(true)}
          wide
        />
      )}

      {systemAlert.linkPaths.length > 0 && (
        <View style={{ marginTop: 10, borderTopWidth: 1 }}>
          <Subtitle>Links</Subtitle>
          {systemAlert.linkPaths.map(linkPath => (
            <Link to={linkPath} target="_blank">
              <Text>{linkPath}</Text>
            </Link>
          ))}
        </View>
      )}

      <Subtitle bordered>Notes</Subtitle>
      <Notes
        systemAlert={systemAlert}
        notes={systemAlert.notes}
        refetch={refetch}
      />

      {documentation && (
        <View style={{ marginTop: 10, borderTopWidth: 1 }}>
          <Subtitle>Documentation - {documentation.name}</Subtitle>
          {documentation.path && (
            <Text style={{ marginBottom: 10}}>Path: {documentation.path}</Text>
          )}
          <Text>{documentation.documentation}</Text>
        </View>
      )}
    </Modal>
  );
};

export default SystemAlert;
